// extracted by mini-css-extract-plugin
module.exports = {"isoCodeContainer":"styles_isoCodeContainer__35KG9","getIconContainer":"styles_getIconContainer__fpUWJ","flag":"styles_flag__2b9l6","container":"styles_container__1Rtko"};